import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { EmptyState, EmptyText } from 'components/customer/answer_panel/lib/empty_state';
import EyeIcon from 'components/lib/icons/eye_icon';

export default function EmptyAnswerPreview() {
  const { t } = useTranslation();
  return (
    <Empty data-aid="emptyAnswerPreview">
      <EyeIcon />
      <EmptyText>{t('Nothing To Show')}</EmptyText>
    </Empty>
  );
}

const Empty = styled(EmptyState)`
  .eyeIcon {
    height: 60px;
    width: 60px;
  }
  .eyeIcon-circle {
    fill: ${p => p.theme.colors.gray100};
  }
  .eyeIcon-stroke {
    stroke: ${p => p.theme.colors.green400};
  }
`;
